/**
 * Subscribe to a media query.
 *
 * The battlefield genuinely behaves differently below 900px rather than just
 * looking different: the log is a sheet that starts closed instead of a dock
 * that starts open. That is a behaviour decision, so it needs the breakpoint in
 * JavaScript and not only in CSS.
 */

import { useEffect, useState } from 'react';

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const list = window.matchMedia(query);
    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches);
    setMatches(list.matches);
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

/** The UI_UX section 8 breakpoint, in one place. */
export const COMPACT_QUERY = '(max-width: 900px)';

export function useIsCompact(): boolean {
  return useMediaQuery(COMPACT_QUERY);
}
